import { render, staticRenderFns } from "./CarisVehicleSelector.vue?vue&type=template&id=362021d4&scoped=true&"
import script from "./CarisVehicleSelector.vue?vue&type=script&lang=js&"
export * from "./CarisVehicleSelector.vue?vue&type=script&lang=js&"
import style0 from "./CarisVehicleSelector.vue?vue&type=style&index=0&id=362021d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362021d4",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcaris-vehicle-selector%2FCarisVehicleSelector.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports